<template>
	<div class="query certificate-query">
		<div
			class="main"
			v-title
			data-title="证书查询-社会美术水平考级管理系统
"
		></div>
		<div class="container">
			<div class="tabs hidden-xs-only">
				<div class="tabs-item">
					<router-link to="/room-query">考场查询</router-link>
				</div>
				<div class="tabs-item active">
					<router-link to="/certificate-query">证书查询</router-link>
				</div>
				<div class="tabs-item">
					<router-link to="/inventory-query">监考证查询</router-link>
				</div>
			</div>
			<!-- 查询表单 -->
			<query-form ref="form" @on-query="handleQuery" :formError="formError" :loading="loading"></query-form>
			<!-- 清除 -->
			<div v-if="resultShow" class="clear" @click="clear">清除</div>
			<!-- 查询结果 -->
			<div ref="result">
				<query-result v-if="resultShow" :data="resultData"></query-result>
			</div>
		</div>
	</div>
</template>
<script>
import queryForm from './components/form';
import queryResult from './components/result';

import { certificate } from '@/api/certificate';

export default {
	name: 'roomQuery',
	data() {
		return {
			resultShow: false,
			formError: {},
			loading: false,
			resultData: []
		};
	},
	components: {
		queryForm,
		queryResult
	},
	methods: {
		handleQuery(form) {
			this.loading = true;
			const ajaxData = {
				...form,
				captcha_value: Number(form.captcha_value),
				per_page: 1000
			};
			certificate(ajaxData)
				.then(res => {
					if (res && res.code === 200) {
						this.resultData = res.data || [];
						this.resultShow = true;
						this.$nextTick(() => {
							window.scrollTo(0, this.$refs.result.offsetTop);
						});
					} else if (res && res.code === 404) {
						this.$notify.error({
							title: '查询结果',
							message: '未查询到相关信息'
						});
						this.$refs.form.getCaptcha();
					} else if (res && res.errors) {
						this.formError = this.$transformError(res.errors);
						this.$refs.form.getCaptcha();
					} else {
						this.$notify.error({
							message: res.message
						});
						this.$refs.form.getCaptcha();
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		clear() {
			this.resultShow = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.query {
	.container {
		width: 60%;
		min-width: 1000px;
		.tabs {
			display: flex;
			.tabs-item {
				flex: 1;
				text-align: center;
				font-size: 14px;
				line-height: 40px;
				cursor: pointer;
				transition: border-color 0.3s;
				a {
					width: 100%;
					height: 100%;
					display: block;
				}
				&.active {
					border-bottom: 2px solid #d8010f;
					color: #d8010f;
				}
				&:hover {
					color: #d8010f;
				}
			}
		}
		.clear {
			margin-top: 10px;
			cursor: pointer;
			text-align: right;
			&:hover {
				color: #d8010f;
			}
		}
	}
}
</style>
